export const SIDEBAR_WIDTH = 217;
export const SIDEBAR_GAP = 20;
export const MAX_FOLDER_LEVEL = 2;
export const BOTTOM_SECTION_HEIGHT = 30;
export const FOLDERS_SIDEBAR_ID = 'automation-folders-sidebar';
